import ReactDOM from 'react-dom';
import { useInstantSearch } from 'react-instantsearch';

import { useTranslation } from '@klv/hooks/useTranslation';
import useAlgoliaHits from './hooks/use-algolia-hits';

import { windowIsDefined } from '@klv/shared/utils/functions';

const UnifiedSearchResultCount = ({ resource }: { resource: string; }) => {
  
  const containerRoot = windowIsDefined() ? document.getElementById('unified-search-result-count') as HTMLElement : null;

  const { t } = useTranslation();

  // get the scoped results & query
  const { uiState } = useInstantSearch();
  const { totalHits, hitsDisplayed } = useAlgoliaHits();

  let message = t('pages_search_resultLabelTop');

  const hasQuery = Object.values(uiState).find(child => child.query)?.query || false;

  // if we do not have a query and our resource is blank.
  if (!hasQuery && resource === '') {
    message = t('pages_search_resultLabelTop');
  } else {
    if (totalHits === 0) {
      message = t('pages_search_resultLabelTop');
    } else {
      // populate our translated string with the appropriate hit-counts
      message = t('pages_search_resultLabelYofX', { y: hitsDisplayed, x: totalHits });
    }
  }

  // if our container does not exist return null.
  if (!containerRoot) return null;
  
  // return our message in a portal
  return ReactDOM.createPortal(
    (
      <div className="p3">
        {message}
      </div>
    ),
    containerRoot,
  );
};

export default UnifiedSearchResultCount;
